import http from "./http-common";

class UserService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  UserDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/accountMaster/list/filter?${queryString}`);
  }
  UserMultipleClinicList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/UserClinicMaster/listAllUserClinicMaster?${queryString}`);
  }
  UserClinicColorCode(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/UserClinicMaster/list/filter?${queryString}`);
  }
  UpdateDefaultClinic(payload) {
    return http.post(`/user/update/defaultClinic`, payload);
  }
  userMultiClinicMapping(payload) {
    return http.post("/UserClinicMaster/", payload);
  }

  getUser(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/user/list/filter?${queryString}`);
  }
}

export default new UserService();
